var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8889 6.35086V3.77944C18.8889 2.35928 17.7447 1.20801 16.3333 1.20801H3.55556C2.14416 1.20801 1 2.35928 1 3.77944V11.4937C1 12.9139 2.14416 14.0652 3.55556 14.0652H6.11111M8.66667 19.208H21.4444C22.8558 19.208 24 18.0567 24 16.6366V8.92229C24 7.50213 22.8558 6.35086 21.4444 6.35086H8.66667C7.25527 6.35086 6.11111 7.50213 6.11111 8.92229V16.6366C6.11111 18.0567 7.25527 19.208 8.66667 19.208ZM17.6111 12.7794C17.6111 14.1996 16.467 15.3509 15.0556 15.3509C13.6442 15.3509 12.5 14.1996 12.5 12.7794C12.5 11.3593 13.6442 10.208 15.0556 10.208C16.467 10.208 17.6111 11.3593 17.6111 12.7794Z",
    filter: "invert(1)",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.a29433dcae5d511fc52bf5b263d9635a.svg";
export { ForwardRef as ReactComponent };